import { useContext } from 'react'
import SidebarContext from './SidebarContext'
import type { SidebarContextType } from './types'

/**
 * Hook to use sidebar context
 */
export function useSidebar(): SidebarContextType {
  const context = useContext(SidebarContext)

  if (context === undefined) {
    throw new Error('useSidebar must be used within a SidebarProvider')
  }

  return context
}
